import * as React from "react";
import PropTypes from 'prop-types';

const SvgMenuIconNew = props => {
  if (props.id !== "_svgmenuiconnew") {
    throw new Error('SVG requires <Icon> component as a parent, e.g. <Icon><SvgLogo></Icon>');
  }

  return <svg viewBox="0 0 24 24" {...props}><path fillRule="evenodd" d="M.75 18h22.5a.75.75 0 110 1.5H.75a.75.75 0 110-1.5zm0-7h22.5a.75.75 0 110 1.5H.75a.75.75 0 110-1.5zm0-7h22.5a.75.75 0 110 1.5H.75a.75.75 0 010-1.5z" /></svg>;
};

SvgMenuIconNew.displayName = "_svgmenuiconnew";
SvgMenuIconNew.propTypes = {
  id: PropTypes.string
};
SvgMenuIconNew.defaultProps = {
  id: ''
};
export default SvgMenuIconNew;